export const BUSINESS_REGISTRATION_UNAVAILABLE_PATH = '/register-business-unavailable';

const RESTRICTED_ROLES = new Set(['consumer', 'admin', 'business_owner']);

export const isBusinessRegistrationBlockedRole = (role) => RESTRICTED_ROLES.has(role);

export const getBusinessRegistrationBlockedReason = (role) => {
  if (role === 'consumer') {
    return {
      title: 'Business registration is not available for consumer accounts.',
      message:
        'You are signed in as a consumer. Consumer accounts cannot register businesses directly.',
      nextSteps: [
        'Log out and create a dedicated business owner account.',
        'Use your business email and complete the business owner registration flow.',
        'If you need role conversion for your existing account, contact support or an admin.',
      ],
    };
  }

  if (role === 'admin') {
    return {
      title: 'Business registration is not available for admin accounts.',
      message:
        'You are signed in as an admin. Admin accounts manage approvals and platform operations, not self-registration.',
      nextSteps: [
        'Create a separate business owner account if you need a business profile.',
        'Keep your admin account only for moderation and management tasks.',
        'If this is your own business onboarding request, ask another admin to assist with setup.',
      ],
    };
  }

  if (role === 'business_owner') {
    return {
      title: 'Business registration is not available for existing business owners.',
      message:
        'Your account is already registered as a business owner. Each business account can only manage one business.',
      nextSteps: [
        'Access your business dashboard to manage your existing business.',
        'If you need to register a new business, create a separate business owner account.',
        'Contact support if you need to manage multiple businesses under one account.',
      ],
    };
  }

  return {
    title: 'Business registration access is currently unavailable.',
    message: 'Your current account cannot access this page.',
    nextSteps: [
      'Check that you are using the correct account type.',
      'Sign in with a business owner account to continue.',
    ],
  };
};
